import {useFragment} from 'react-relay'
import {graphql} from 'relay-runtime'
import type {MilestoneRow$key} from './__generated__/MilestoneRow.graphql'
import {ListItem} from '@github-ui/list-view/ListItem'
import {ListItemMainContent} from '@github-ui/list-view/ListItemMainContent'
import {ListItemDescription} from '@github-ui/list-view/ListItemDescription'
import {MilestoneDate} from './MilestoneDate'
import {MilestoneRowTitle} from './MilestoneRowTitle'
import {MilestoneRowMetadata} from './MilestoneRowMetadata'

type MilestoneRowProps = {
  milestone: MilestoneRow$key
}

export function MilestoneRow({milestone}: MilestoneRowProps) {
  const data = useFragment(
    graphql`
      fragment MilestoneRow on Milestone {
        description
        id
        ...MilestoneRowTitle
        ...MilestoneRowMetadata
        ...MilestoneDate
      }
    `,
    milestone,
  )

  const title = <MilestoneRowTitle milestone={data} />

  const metadata = <MilestoneRowMetadata milestone={data} />

  return (
    <ListItem key={data.id} title={title} role="listitem" metadata={metadata}>
      <ListItemMainContent>
        <ListItemDescription>
          {data.description}
          <MilestoneDate milestone={data} />
        </ListItemDescription>
      </ListItemMainContent>
    </ListItem>
  )
}

try{ MilestoneRow.displayName ||= 'MilestoneRow' } catch {}